export default "__VITE_ASSET__BX9Xjle6__"